function Copyright() {
  return <p>&copy; 2024 Alferid Hassen. All rights reserved.</p>;
}

export default Copyright;
